const reducer = (state, { type, payload }) => {
  // console.log(type, payload, state);
  switch (type) {
    case "CLEAR_SESSION":
      return {
        sessionLoaded: true,
      }
    case "SET_SESSION":
      return {
        ...state,
        ...payload,
        sessionLoaded: true,
      }
    case "SET_SESSION_DATA":
      return {
        ...state,
        sessionLoaded: true,
        sessionData: state.sessionData ? { ...state.sessionData, ...payload } : payload,
      }
    default:
      return state
  }
}

export default reducer;